import { render, staticRenderFns } from "./InventoryPricing.vue?vue&type=template&id=4b909410&scoped=true"
import script from "./InventoryPricing.vue?vue&type=script&lang=js"
export * from "./InventoryPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b909410",
  null
  
)

export default component.exports